import { BaseService } from './BaseService';
export interface SiteStorageInfo {
  usedBytes: number; limitBytes: number; resourceId: string; accountId: string;
  generateImageSizes: boolean; canManageBilling: boolean; canManageSettings: boolean;
}
export class SiteStorageService extends BaseService {
  async get(): Promise<SiteStorageInfo> {
    const value = await this._ajaxService.Get<SiteStorageInfo>(`/SiteStorage/${this.siteKey}`, true);
    if (!value) throw new Error('Unable to check site storage.');
    return value;
  }
  async setGenerateImageSizes(enabled: boolean): Promise<void> {
    await this._ajaxService.Post(`/SiteStorage/${this.siteKey}/settings`, { generateImageSizes: enabled }, true);
  }
}
